import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { useFrameStore } from '../seg-frame-store';
import { TABS } from '../helpers/frameConstants';
import PrintQuotePage from './PrintQuotePage.vue';
import PrintProductionPage from './PrintProductionPage.vue';
import PrintGuidePage from './PrintGuidePage.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PrintWrapper',
    setup(__props, { expose: __expose }) {
        __expose();
        const store = useFrameStore();
        /**
         * If the collection has items, print those; otherwise fall back to the
         * currently-active frame so a single-frame workflow doesn't require stashing first.
         */
        const framesToPrint = computed(() => {
            if (store.frameCollection.length > 0)
                return store.frameCollection;
            if (store.activeFrameData) {
                return [{ ...store.activeFrame, id: 'active-frame' }];
            }
            return [];
        });
        const __returned__ = { store, framesToPrint, get TABS() { return TABS; }, PrintQuotePage, PrintProductionPage, PrintGuidePage };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
